import { AfterViewInit, Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { BaseInputComponent } from '../base-input/base-input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormEvent } from '../../../crud/form/form-event.enum';

declare const $: JQuery;

export type ColorFormat = 'RGB' | 'HEX';

@Component({
  selector: 'colorpicker',
  templateUrl: './colorpicker.component.html',
  styleUrls: ['./colorpicker.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ColorpickerComponent),
    multi: true,
  }],
})
export class ColorpickerComponent extends BaseInputComponent implements AfterViewInit {

  @Input() colorFormat: ColorFormat = 'RGB';
  @Input() displayValue = false;
  @Output() previewColor = new EventEmitter();
  @ViewChild('colorpicker', { static: false }) colorpickerEl: ElementRef;

  ngAfterViewInit(): void {
    const control = this.form.controls[this.formControlName];
    const formattedColor = (color: any) => {
      switch (this.colorFormat) {
        case 'RGB':
          return color.toRgbString();
        case 'HEX':
          return color.toHexString();
      }

    };
    $(this.colorpickerEl.nativeElement).spectrum({
      showAlpha: true,
      showInput: true,

      change: (color: any) => {
        control.setValue(formattedColor(color));
        this.onChange({ target: { value: formattedColor(color) } });
      },
      move: (color: any) => {
        this.previewColor.emit({ target: { value: formattedColor(color) } });
      },
      hide: (color: any) => {
        this.previewColor.emit({ target: { value: this.innerValue } });
      },
    });

    control.valueChanges.subscribe(
      (data: any) => {
        $(this.colorpickerEl.nativeElement).spectrum('set', control.value);
      },
    );

    this.channel.subscribe((event: FormEvent) => {
      if (event === FormEvent.SUBMIT) {
        if (this.form.controls[this.formControlName].invalid) {
          this.toggleInvalidClass(true);
          this.renderErrors();
        } else {
          this.toggleInvalidClass(false);
        }
      }
    });
  }
}
